import { createQuery } from "react-query-kit";

import type { IAvailableDoctorListEndpoint } from ".";

import type {
  AxiosError,
  IApiResponse,
  IAxiosFn,
  IKeywordParams,
  IPaginationParams,
  IWithFilters,
  IWithPagination,
  IWithStats,
} from "@/api";
import { axiosClient } from "@/api";

const key = "available-doctor-list";

type IResponse = IApiResponse<
  IWithFilters<IWithStats<IWithPagination<IAvailableDoctorListEndpoint>>>
>;
export type IVariables = IPaginationParams & IKeywordParams;

const getAvailableDoctorsAPI: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  const { data } = await axiosClient.get("/doctors", {
    params,
    signal,
  });

  return data;
};

export const useAvailableDoctorList = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getAvailableDoctorsAPI(variables, signal),
});
